// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  receiptKey: __t.string().primaryKey().name("receipt_key"),
  actor: __t.identity(),
  owner: __t.identity(),
  shipId: __t.u64().name("ship_id"),
  target: __t.string(),
  outcome: __t.string(),
  before: __t.u32(),
  after: __t.u32(),
  add: __t.u32(),
  eligibleRestored: __t.u32().name("eligible_restored"),
  kitSerial: __t.string().name("kit_serial"),
  epoch: __t.u32(),
  detail: __t.string(),
  at: __t.timestamp(),
});
